import request from '../index'

//获取行业解决方案详情
export function getSolutionDetails(id) {
	return request({
		url: '/plan/info' + '?id=' + id,
		method: 'get',
	})
}
